import { Select } from "antd";
import React from "react";

const TransportationMode = ({ setFormData, formData, disabled = false }) => {
  return (
    <Select
      // className="w-full h-8 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
      name="modeOfTransfer"
      id="modeOfTransfer"
      onChange={(e) => {
        setFormData((prevData) => ({
          ...prevData,
          modeOfTransfer: e,
        }));
      }}
      value={formData.modeOfTransfer}
      showSearch
      disabled={disabled}
      options={[
        { label: "By Air", value: "By Air" },
        { label: "By Road", value: "By Road" },
        { label: "By Sea", value: "By Sea" },
      ]}
    ></Select>
  );
};

export default TransportationMode;